var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"disabled":"","dense":"","label":_vm.$t('examination.assignExaminationsForm.groupName')},model:{value:(_vm.value.name),callback:function ($$v) {_vm.$set(_vm.value, "name", $$v)},expression:"value.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }